import React from 'react';
import Axios from 'axios';

class SeasonsTableList extends React.Component {

  constructor(props) {
		super(props);
		this.state = {};

		this.createSeasonRow = this.createSeasonRow.bind(this);
		this.handleCumulClick = this.handleCumulClick.bind(this);
	}

	render() {
		//console.log('SeasonsTableList: render')
		return (
			<div>
				<table className="table table-striped table-hover table-responsive table-sm">
				<tbody>
					<tr>
						<th>ID</th>
						<th>Saisons</th>
						<th>Active</th>
						<th>SousSaisons</th>
						<th></th>
					</tr>
					{this.props.seasons.map(this.createSeasonRow)}
				</tbody>
				</table>
			</div>
		);
	}

	createSeasonRow(season, seasonIdx) {
		return (
			<tr key={season._id}>
				<td>{season._id}</td>
				<td>{season.name}</td>
				<td>{season.status}</td>
				<td>{season.subSeasons.length}</td>
				<td><input name={'edit.' + season._id} type="button" onClick={this.handleCumulClick} value="Cumuler Stats"/></td>
			</tr>
		);
	}

	handleCumulClick(e) {
		var elemInfo = e.target.name.split(".");
		var seasonId = elemInfo[1];
		Axios.post('/api/scoresheets/computeCumulativeResults', {
			seasonId: seasonId
		})
		.then(function(response) {
			console.log('success: ' + seasonId);
		})
		.catch(function(error) {
			console.log(error);
		});
	}

};

export default SeasonsTableList;